module.exports = __webpack_public_path__ + "img/screen-manual-13.5f3fc039.png";